import QuestionCreator from '../questionCreator';
import TaskDetails from '../../../components/shared/TaskDetails';

import { IQuestionComponentProps } from '../types';

import { HISTORY_TYPE } from '../../../constants';

import imgDna from '/images/dna.svg';

const HospitalExperienceComponent: React.FC<IQuestionComponentProps> = ({
  isQuestionnaireComplete,
  questionnaires,
  toggleQuestionnaireCompletion,
  navigateToTasks,
}) => {
  if (isQuestionnaireComplete) {
    return (
      <TaskDetails
        title="Hospital experience"
        description="Share your past hospital admissions and medical conditions to help us provide comprehensive care."
        buttonText="Complete questionnaire"
        imgSrc={imgDna}
        imgAlt="dna"
        imgWidth="254px"
        handleClick={toggleQuestionnaireCompletion}
        handleClose={navigateToTasks}
      />
    );
  }

  if (questionnaires)
    return (
      <QuestionCreator
        questionnaires={questionnaires}
        historyType={HISTORY_TYPE.HOSPITAL_EXPERIENCE}
      />
    );

  return null;
};

export default HospitalExperienceComponent;
